import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GetOrCreateResponse, ResidentialService } from '../../../core/services/residential.service';
import { Address } from 'ngx-google-places-autocomplete/objects/address';

@Component({
  selector: 'ui-address',
  templateUrl: './ui-address.component.html',
  styleUrls: ['./ui-address.component.scss']
})
export class UiAddressComponent {
  @Input() form: FormGroup;
  @Output() setBuildingsFromAddress = new EventEmitter();
  @Output() setUnitsFromAddress = new EventEmitter();
  @Output() setAccountId = new EventEmitter();
  @Output() setCommunity = new EventEmitter();

  constructor(private residentialService: ResidentialService) { }

  handleAddressChange(googleAddress: Address) {
    const formattedAddress = this.residentialService.formatAddress(this.form.get('address').value, googleAddress);
    this.form.get('address').setValue(formattedAddress);
    const county = this.getLongName(this.setAddressPart(googleAddress, 'administrative_area_level_2'));
    const neighborhood = this.getLongName(this.setAddressPart(googleAddress, 'neighborhood'));
    this.form.get('county').setValue(county);
    this.form.get('neighborhood').setValue(neighborhood);
    this.getOrCreate();
  }

  getOrCreate(): void {
    this.form.get('insurable_id').setValue(null);
    this.form.get('address').setErrors(null);
    const form = this.form.value;
    this.residentialService.getOrCreateInsurable(form)
      .subscribe((result: GetOrCreateResponse) =>  {
        const community = result && result.results && result.results[0] ? result.results[0] : null;
        if (community) {
          this.validateStates(community)
          this.setCommunity.emit(community);
        }
        if (community && community.id) {
          this.form.get('insurable_id').setValue(community.id);
        }
        const accountId = community && community.account_id ? community.account_id : null;
        if (accountId) {
          this.setAccountId.emit(accountId);
        }
        this.setBuildings(community);
        this.setUnits(community);
      });
  }

  validateStates(community) {
    const primaryAddress = community && community.primary_address ? community.primary_address : null
    const state = primaryAddress && primaryAddress.state ? primaryAddress.state : null;
    if (state === 'AK') {
      this.form.get('address').setErrors({ invalidState: true });
    }
  }

  setAddressPart(googleAddress, part) {
    return googleAddress.address_components.find(ac => (ac.types || []).includes(part));
  }

  getLongName(address) {
    return address && address.long_name ? address.long_name : '';
  }

  setBuildings(community) {
    const buildings = community && community.buildings ? community.buildings : [];
    this.setBuildingsFromAddress.emit(buildings);
  }

  setUnits(community) {
    const units = community && community.units ? community.units : [];
    this.setUnitsFromAddress.emit(units);
  }
}
